import {
  ITEM_ERROR_DATA,
  ITEM_LIST_DATA,
  LOADER_STATUS,
  SAVE_TOTAL_PAGES,
  TABLE_DATA,
  TOTAL_RECORDS,
  TXN_ERROR_DATA,
} from "./constants";

export const initialState = {
  loaderStatus: false,
  tableData: [],
  totalPages: 1,
  totalRecords: 1,
  itemErrorData: [],
  txnErrorData: [],
  itemListData:[]
};

/* eslint-disable default-case, no-param-reassign */
const EinvFailedReducerNew = (state = initialState, action) => {
  switch (action.type) {
    case LOADER_STATUS:
      return {
        ...state,
        loaderStatus: action.loaderStatus,
      };
    case TABLE_DATA:
      return {
        ...state,
        tableData: action.tableData,
      };
    case SAVE_TOTAL_PAGES:
      return {
        ...state,
        totalPages: action.totalPages,
      };
    case TOTAL_RECORDS:
      return {
        ...state,
        totalRecords: action.totalRecords,
      };
    case ITEM_ERROR_DATA:
      return {
        ...state,
        itemErrorData: action.itemErrorData,
      };
    case TXN_ERROR_DATA:
      return {
        ...state,
        txnErrorData: action.txnErrorData,
      };
      case ITEM_LIST_DATA:
      return {
        ...state,
        itemListData: action.itemListData,
      };
    default:
      return state;
  }
};

export default EinvFailedReducerNew;
